module.exports = __webpack_public_path__ + "static/fish-5-b8b3c09b8d896c1d0b93d66659c68958.jpg";